import template from './refineTasksExplainer.html';
import controller from './RefineTasksExplainerController';

function refineTasksExplainer() {
  return {
    restrict: 'E',
    template,
    controller: 'RefineTasksExplainerController'
  };
}

export default function (ngModule) {
  ngModule.directive('refineTasksExplainer', refineTasksExplainer);
  controller(ngModule);
}
